export function hostname() {
  var production = true;
  // var production = false;
  if (production) {
    return location.host;
  } else {
    // return '177.207.228.138:444'
    // return '172.55.20.250:443'
    // return '179.178.193.178:83'
    // return '172.55.20.242:443'
    // return 'pcm2.pcmsolucoes.com.br:443'
    // return 'pcm1.pcmsolucoes.com.br:443'
    // return '172.55.20.101:443'
    // return "177.207.231.74:446";
    // return "179.179.137.217:446";
    // return "189.27.115.151:446";
    // return "pcm.ddns.com.br:446";
    // return "pcm.ddns.com.br:449";
    // return "pcm.ddns.com.br:449";
    // return "192.168.25.101:443";
    // return "webrtc104.pcmsolucoes.com.br:443";
    // return "pcm.ddns.com.br:51109";
    return "pcm.ddns.com.br:51109";
  }
}
